module.exports = __webpack_public_path__ + "static/media/image4.caf3dbd4.png";